export const selectModeCardItemData = [
  {
    title: 'کارشناس',
    description: 'قبلا ثبت نام کرده ام و به عنوان کارشناس مشغول به کار هستم ',
    value: 'expert' as const,
  },
  {
    title: 'متقاضی همکاری',
    description: 'میخواهم به‌عنوان کارشناس مشغول به فعالیت شوم',
    value: 'job-applicant' as const,
  },
];
